<template>
  <!-- <div class="cactus-groups">
    <div v-for="(el, index) in groups" :key="index">
      <cactus-group :cactus-group="el"></cactus-group>
    </div>
  </div> -->
  <div class="cactus-groups">
    <cactus-group
      v-for="(el, index) in groups"
      :cactus-group="el"
      :item="el"
      :title="getCactusString(el.label)"
      :key="index"
      :multiple="true"
      :readOnly="false"
    >
    </cactus-group>
  </div>
</template>

<script>
import CactusStrings from './CactusStringsMixin';
import Accordion from '../_ui/accordion/Accordion';
// import AccordionItem from '../_ui/accordion/AccordionItem';
import CactusGroup from './CactusGroup.vue';

export default {
  name: 'CactusGroups',
  extends: Accordion,
  mixins: [CactusStrings],
  components: {
    CactusGroup
  },
  props: {
    groups: {
      type: Array,
      default: () => []
    }
  },
  created() {
    this.$log.debug('CactusGroups::created()');
    // this.readOnly = false;
  }
};
</script>

<style lang="scss" scoped>
.cactus-groups {
  &__item {
    display: flex;
    flex-direction: column;
  }
}
</style>
